import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type State = {
  baseUrl: string;
  enabledSocialConnections: string[];
  showPublicSections: boolean;
  isAboutInstalled: boolean;
  memberProfileURL: string;
};

export const siteSlice = createSlice({
  name: 'site',
  initialState: {
    baseUrl: '',
    isSSOMandatory: false,
    enabledSocialConnections: [] as string[],
    showPublicSections: false,
    isAboutInstalled: false,
    memberProfileURL: '',
  },
  reducers: {
    setBaseUrl(state, { payload }: PayloadAction<string>) {
      state.baseUrl = payload;
    },
  },
});
